import type { Conference } from '../types/content';

export const conferences: Conference[] = [
  { name: 'StreamTV', detail: 'Global Streaming & Digital Media Summit' },
  { name: 'NEM Dubrovnik', detail: 'New Europe Market Executive Forum' },
  { name: 'MIPCOM', detail: 'International Content & Media Market' }
];
